import { ApprRouteDialog } from '@/common/appr/ApprRouteDialog';
import { useDialog } from '@/common/dialog/DialogContext';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { useEntityFromRoute } from '@/common/hooks/route/useEntityFromRoute';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { usePrincipal } from '@/common/principal/PrincipalContext';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { TitleButton } from './TitleButton';

export const ApprButton = ({ selectedEntities }) => {
  const { openDialog } = useDialog();
  const { entityDef, entityObj, asOfDate, hist } = useEntityMgr();
  const module = useModuleFromRoute();
  const entity = useEntityFromRoute();

  // Only render if the use has appropriate Role
  const { hasRole } = usePrincipal();
  if (!hasRole(`${module.toUpperCase()}_${entity}_SAVE`)) return;

  // TODO: ah review, putting here for use in disable
  const entityObjs = selectedEntities ?? [entityObj];

  const submitForAppr = () => {
    const data = {
      module,
      entity,
      entityObjs: entityObjs,
      entityDisplayName: entityDef.displayName,
    };
    openDialog(ApprRouteDialog, { data });
  };

  return (
    <TitleButton
      dataTestId={'appr-button'}
      icon={fas.faUserCheck}
      disabled={
        hist ||
        asOfDate ||
        (entityDef.validatable &&
          !entityObjs.every((entityObj) => ['VALID', 'WARN', 'ERROR'].includes(entityObj.valStatus))) || // TODO!! check if error is the move
        (entityDef.approvable && !entityObjs.every((entityObj) => entityObj.status === 'DRAFT')) ||
        entityObjs.length === 0
      }
      toolTip="Submit for Approvals"
      onClick={submitForAppr}
    />
  );
};
